export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) return null;
  if (phoneNumber.match(/\d{3}\-\d{3}\-\d{4}/)) return phoneNumber;

  const formattedPhoneNumber = phoneNumber.replace(/\D/g, '');
  return formattedPhoneNumber.length === 10
    ? formattedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    : phoneNumber;
}
